import {
  IPlatformAppEvent,
  IPlatformPrivateEvent,
  PlatformAppEventEmitter,
} from '@wix/public-editor-platform-events';
import {
  IPlatformSDKContext,
  PlatformEnvironment,
} from '@wix/editor-platform-contexts';

import { ApplicationEventsBridge } from '../ApplicationEventsBridge';
import { IPrivateAPIFixMe } from '../types';

import {
  AbstractEnvironmentAPI,
  PlatformConsumerEnvironmentAPIType,
} from '../AbstractEnvironmentAPI';

const DESIGN_SYSTEM_STYLES_MAP = {
  classic:
    'https://www.unpkg.com/@wix/design-system/dist/statics/tokens-default.global.css',
  studio:
    'https://www.unpkg.com/@wix/design-system/dist/statics/tokens-studio.global.css',
};

export class PlatformFrameAPI extends AbstractEnvironmentAPI<
  PlatformConsumerEnvironmentAPIType.Frame,
  PlatformEnvironment.Frame
> {
  #events = new PlatformAppEventEmitter();
  #eventsBridge = new ApplicationEventsBridge(this.#events);
  #privateAPI: IPrivateAPIFixMe;
  #applicationPrivateAPI: any;

  constructor() {
    super(PlatformConsumerEnvironmentAPIType.Frame, PlatformEnvironment.Frame);

    this.#injectGlobalCSSTokens();
  }

  #injectGlobalCSSTokens() {
    if (typeof globalThis?.document?.head?.prepend === 'function') {
      const params = new URL(globalThis.location.href).searchParams;

      // TODO: check all possible editorType values
      const host =
        params.get('editorType') === 'CLASSIC' ? 'classic' : 'studio';

      const url = DESIGN_SYSTEM_STYLES_MAP[host];

      const isAlreadyLoaded =
        url &&
        !!document.querySelectorAll(`link[type="text/css"][href="${url}"]`)
          ?.length;

      if (url && !isAlreadyLoaded) {
        const link: HTMLLinkElement = document.createElement('link');

        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('href', url);

        globalThis.document.head.prepend(link);
      }
    }
  }

  /**
   *
   * We need to introduce context versions
   * to simplify handling the backward compatibility issues
   */
  async initEnvironment(props: {
    // backward-compatibility
    appDefinitionId?: string;
    context: IPlatformSDKContext;
    privateAPI: IPrivateAPIFixMe;
    applicationPrivateAPI: any;
  }) {
    const { applicationPrivateAPI, privateAPI, context } = props;

    /**
     * backward-compatibility
     */
    const _appDefinitionId =
      props.context?.appDefinitionId ?? props.appDefinitionId;

    const _context = props.context
      ? props.context
      : {
          appDefinitionId: _appDefinitionId,
        };

    this.#applicationPrivateAPI = applicationPrivateAPI;
    this.#privateAPI = privateAPI;

    await this.injectEnvironmentContext({
      privateApi: privateAPI,
      events: this.#events,
      applicationAPIs: _appDefinitionId
        ? {
            [_appDefinitionId]: this.#applicationPrivateAPI,
          }
        : {},
    });

    await this.injectApplicationContext(_context);
  }

  notify(event: IPlatformPrivateEvent) {
    this.#eventsBridge.notify(event);
  }

  subscribe(cb: (event: IPlatformAppEvent) => void) {
    this.#eventsBridge.subscribe(cb);
  }
}
